export default "__VITE_ASSET__BSNzvRbj__"